import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';

var _this = this;

export default (function (_ref, inject) {
    var $axios = _ref.$axios;

    $axios.$downloadFile = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, dataFile) {
            var response, data, headers, URL, filename, link;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return $axios.post(url, dataFile, {
                                responseType: 'blob'
                            });

                        case 2:
                            response = _context.sent;
                            data = response.data, headers = response.headers;
                            URL = window.URL.createObjectURL(data);
                            filename = headers['content-disposition'].replace('attachment; filename=', '');
                            link = document.createElement('a');

                            link.href = URL;
                            link.setAttribute('download', filename);
                            document.body.appendChild(link);
                            link.click();

                        case 11:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x, _x2) {
            return _ref2.apply(this, arguments);
        };
    }();
});


//////////////////
// WEBPACK FOOTER
// ./src/plugins/axios-download.js
// module id = ./src/plugins/axios-download.js
// module chunks = 34